var isDefined = function isDefined(prop) {
  return typeof prop !== "undefined";
};

export default isDefined;